import { useMemo } from "react";
import { getBizType, THEME, fm, today, dayName } from "../utils/helpers";
import { getDailyTip } from "../utils/nlp";

export default function Home({ config, transactions, onNavigate }) {
  const biz = getBizType(config.businessType);
  const todayTxns = useMemo(() => transactions.filter((t) => t.date === today()), [transactions]);
  const tv = todayTxns.filter((t) => t.type === "vente").reduce((s, t) => s + t.amount, 0);
  const td = todayTxns.filter((t) => t.type === "depense").reduce((s, t) => s + t.amount, 0);

  return (
    <div style={{ minHeight: "100vh", background: THEME.bg }}>
      {/* Hero */}
      <div style={{
        background: `linear-gradient(150deg, ${biz.color} 0%, ${biz.color}cc 100%)`,
        padding: "28px 20px 24px", color: "#fff",
        borderRadius: "0 0 28px 28px",
        boxShadow: `0 8px 30px ${biz.color}33`,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 13, opacity: 0.8 }}>{dayName(today())}</div>
            <div style={{ fontSize: 22, fontWeight: 900, marginTop: 4 }}>{config.businessName}</div>
          </div>
          <div style={{ fontSize: 36 }}>{biz.icon}</div>
        </div>
        {todayTxns.length > 0 && (
          <div style={{
            display: "flex", gap: 16, marginTop: 18,
            background: "rgba(255,255,255,0.15)", borderRadius: 14, padding: "12px 16px",
          }}>
            {[
              { l: "Ventes", v: tv },
              { l: "Dépenses", v: td },
              { l: "Bénéfice", v: tv - td },
            ].map((s, i) => (
              <div key={i} style={{ flex: 1, textAlign: i === 1 ? "center" : i === 2 ? "right" : "left" }}>
                <div style={{ fontSize: 10, opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}>{s.l}</div>
                <div style={{ fontSize: 17, fontWeight: 900 }}>{fm(s.v)} F</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ padding: "20px 16px 100px" }}>
        {/* Daily tip */}
        <div style={{
          background: `${THEME.gold}10`, border: `1px solid ${THEME.gold}30`,
          borderRadius: 14, padding: "12px 14px", marginBottom: 20,
          display: "flex", alignItems: "flex-start", gap: 10,
        }}>
          <span style={{ fontSize: 20, flexShrink: 0 }}>💡</span>
          <div style={{ fontSize: 13, color: "#7a6a4a", lineHeight: 1.5, fontWeight: 500 }}>
            {getDailyTip()}
          </div>
        </div>

        <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 12 }}>Qui êtes-vous ?</div>

        {/* Employee buttons */}
        {config.employees.map((emp, idx) => (
          <button key={emp.id} onClick={() => onNavigate("chat", emp)} style={{
            display: "flex", alignItems: "center", gap: 14, width: "100%",
            padding: "14px 16px", marginBottom: 8,
            background: "#fff", border: `1.5px solid ${THEME.border}`,
            borderRadius: 16, cursor: "pointer", textAlign: "left",
            fontFamily: THEME.font, transition: "all 0.15s ease",
            animation: `fadeUp 0.4s ease ${idx * 0.06}s both`,
          }}>
            <div style={{
              width: 48, height: 48, borderRadius: 14,
              background: `${biz.color}12`,
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24,
            }}>{emp.avatar}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 800 }}>{emp.name}</div>
              <div style={{ fontSize: 12, color: THEME.textSub }}>{emp.role}</div>
            </div>
            <div style={{
              background: `${THEME.whatsappLight}18`, borderRadius: 10,
              padding: "6px 12px", fontSize: 12, fontWeight: 700, color: THEME.whatsappLight,
            }}>💬 Saisie</div>
          </button>
        ))}

        {/* Solo mode */}
        {config.employees.length === 0 && (
          <button onClick={() => onNavigate("chat", null)} style={{
            display: "flex", alignItems: "center", gap: 14, width: "100%",
            padding: "16px", marginBottom: 8,
            background: "#fff", border: `1.5px solid ${THEME.border}`,
            borderRadius: 16, cursor: "pointer", textAlign: "left",
            fontFamily: THEME.font, animation: "fadeUp 0.4s ease both",
          }}>
            <div style={{
              width: 48, height: 48, borderRadius: 14,
              background: `${THEME.whatsappLight}15`,
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24,
            }}>💬</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 800 }}>{config.ownerName}</div>
              <div style={{ fontSize: 12, color: THEME.textSub }}>Saisir mes transactions</div>
            </div>
            <div style={{ color: THEME.whatsappLight, fontSize: 22 }}>→</div>
          </button>
        )}

        {/* Boss dashboard */}
        <button onClick={() => onNavigate("pin")} style={{
          display: "flex", alignItems: "center", gap: 14, width: "100%",
          padding: "16px", marginTop: config.employees.length > 0 ? 12 : 4,
          background: "#1a1a1a", border: "none",
          borderRadius: 16, cursor: "pointer", textAlign: "left",
          fontFamily: THEME.font, animation: "fadeUp 0.4s ease 0.2s both",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}>
          <div style={{
            width: 48, height: 48, borderRadius: 14,
            background: `${biz.color}25`,
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24,
          }}>📊</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 800, color: "#fff" }}>Tableau de bord</div>
            <div style={{ fontSize: 12, color: "#888" }}>Patron • Protégé 🔒</div>
          </div>
          <div style={{
            background: biz.color, borderRadius: 10,
            padding: "6px 12px", fontSize: 12, fontWeight: 700, color: "#fff",
          }}>Ouvrir</div>
        </button>
      </div>
    </div>
  );
}
